export default __webpack_public_path__ + "static/media/lab2.68301e1d.png";